import dateMatcher from "./dateMatcher";
export function filterFeedbacksWithinDates(mainData1, fromDate, tillDate) {
  //   let mainData1 = JSON.parse(sessionStorage.getItem("mainData"));
  let newData = mainData1?.filter((item) => {
    // console.log(dateMatcher(item.createdAt, dFrom, dTill));

    // below dateMatcher returns true if item.createdAt falls between
    // dFrom and Dtill dates. and Filter function sends those items in
    // newData object if dateMatcher returns true.

    return dateMatcher(item.createdAt, fromDate, tillDate);
  });

  return newData;
}
